<div class="importar-xml-etapa">
  @if (!arquivo) {
  <app-file-dropzone accept=".xml" [multiple]="false"
    label="Solte o arquivo XML aqui ou clique para selecionar"
    hint="Somente arquivo .xml, até 10 MB"
    (filesSelected)="onFilesSelected($event)">
  </app-file-dropzone>
  } @else {
  <input #arquivoSubstituto type="file" accept=".xml" hidden (change)="onArquivoSubstituido($event)">
  <div class="importar-xml-drop-zone importar-xml-drop-zone--arquivo" role="button" tabindex="0"
    (click)="arquivoSubstituto.click()"
    (keydown.enter)="arquivoSubstituto.click()"
    (keydown.space)="arquivoSubstituto.click(); $event.preventDefault()">
    <mat-icon class="material-symbols-outlined importar-xml-drop-zone-icon">check_circle</mat-icon>
    <p class="importar-xml-drop-zone-title">{{ arquivo.nome }}</p>
    <p class="importar-xml-drop-zone-subtitle">{{ tamanhoArquivo() }} · Clique ou toque para trocar</p>
  </div>
  }
</div>
